/** Max-width container on any viewport (matches app `$mobileWidth: 480px`). */
export const layoutDimensions = {
  containerMaxWidth: 480,
  containerMaxWidthPx: '480px',
  touchTargetMin: 44,
  navBarHeight: 56,
  tabBarHeight: 65,
  /** Fixed/static page action bar height (list pages with bottom CTA). */
  actionBarHeight: 80,
  /** Detail pages with a single bottom button. */
  detailFooterHeight: 70
} as const;

export type LayoutDimensions = typeof layoutDimensions;

export const mobileShellClassName =
  'mx-auto min-h-dvh w-full max-w-mobile overflow-x-hidden bg-white';

export const shellClassName = `${mobileShellClassName} flex flex-col`;

export const safeAreaClassName =
  'pt-[max(0px,env(safe-area-inset-top))] pb-[max(0px,env(safe-area-inset-bottom))] pl-[max(0px,env(safe-area-inset-left))] pr-[max(0px,env(safe-area-inset-right))]';

export const tabBarInnerHeightClassName = 'h-[65px]';

export const tabBarPaddingClassName = 'pb-[calc(65px+env(safe-area-inset-bottom,0px))]';

export const actionBarPaddingClassName = 'pb-20';
